import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { CreateHolidaysEndAlertSuccess } from '@app/+product/store/actions/product.action';
import { OTHER_BRAND } from './utils';
/**
 * On product pages, the seller is on vacations and when user wants a notification when product is available again.
 */
const events = getEvents((action: CreateHolidaysEndAlertSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'CreateSellerHolidaysEndAlert',
      product_brand: action.payload.brand.id === OTHER_BRAND.id ? OTHER_BRAND.name : action.payload.brand.name,
      product_category: action.payload.category.name,
      product_univers: action.payload.universe.name
    }
  },
  {
    type: 'Create Seller Holidays End Alert',
    container: TagContainer.Media
  }
]);

export default events;
